/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, OnInit, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BeerPongTableDto, BeerPongTableEndpointService } from 'openapi-generated';
import { Router } from '@angular/router';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatChipTrailingIcon, MatChipsModule } from '@angular/material/chips';
import { MatCard } from '@angular/material/card';
import { ConfirmationService } from '../../services/confirmation.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { HeaderCardComponent } from '../header-card/header-card.component';

@Component({
  selector: 'app-beer-pong-table-overview',
  templateUrl: './beer-pong-table-overview.component.html',
  styleUrls: ['./beer-pong-table-overview.component.scss'],
  standalone: true,
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderCellDef,
    MatIcon,
    MatCellDef,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    MatButton,
    MatIconButton,
    MatChipsModule,
    MatChipTrailingIcon,
    MatCard,
    HeaderCardComponent,
  ],
})
export class BeerPongTableOverviewComponent implements OnInit {
  tables = signal<BeerPongTableDto[]>([]);
  displayedColumns: string[] = ['name', 'actions'];
  tournamentId: number | undefined;

  constructor(
    private beerPongTableService: BeerPongTableEndpointService,
    private snackBar: MatSnackBar,
    private confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.tournamentId = Number(params.get('tournamentId'));
      this.loadBeerPongTables();
    });
  }

  async openConfirmDialog(id: number): Promise<void> {
    if (
      await this.confirmationService.openConfirmationDialog(
        'delete beer pong table',
        'Are you sure you want to delete this beer pong table?',
        true,
        'Delete',
      )
    ) {
      this.deleteBeerPongTable(id);
    }
  }

  private loadBeerPongTables() {
    if (!this.tournamentId) {
      this.snackBar.open('Mo Tournament Selected', 'Close', { duration: 3000 });
      return;
    }
    this.beerPongTableService.findBeerPongTablesByTournamentId(this.tournamentId).subscribe({
      next: data => {
        console.log(data);
        this.tables.set(data);
      },
      error: () => {
        this.snackBar.open('Failed to load beer pong tables', 'Close', { duration: 3000 });
      },
    });
  }

  editBeerPongTable(id: number) {
    this.router.navigate([`${id}/update`], { relativeTo: this.route });
  }

  deleteBeerPongTable(id: number) {
    this.beerPongTableService.deleteBeerPongTable(id).subscribe({
      next: () => {
        this.snackBar.open('Beer pong table deleted successfully', 'Close', { duration: 3000 });
        this.loadBeerPongTables();
      },
      error: () => {
        this.snackBar.open('Failed to delete beer pong table', 'Close', { duration: 3000 });
      },
    });
  }

  backToOverview() {
    this.router.navigate([`/admin/tournaments/` + this.tournamentId]);
  }

  createBeerPongTable() {
    this.router.navigate(['create'], { relativeTo: this.route });
  }
}
